import React from 'react';
import s from './InterestingObjects.module.css';

// 'img-id-15': { title: 'test13', img: 'https://source.unsplash.com/random/190x160' },


const InterestingObjects = () => {
  return (
    <div className={s.cont}>

    </div>
  );
};

export default InterestingObjects;
